module.exports = __webpack_public_path__ + "assets/img/19.46fc5838.png";